import { OrderFormProductDTO } from 'support/types/dtos';

export const useProductPricePerUnit = (product: OrderFormProductDTO) => {
  return product.parts && product.parts.length > 0 ? product.parts[0].discounted_unit_price : null;
};
